import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { InvoiceData } from '../../../utils/models/InvoiceData';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RFCsService } from '../../../utils/services/rfcs.service';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { FormFacturaComponent } from '../form-factura/form-factura.component';

@Component({
  selector: 'app-list-facturas',
  templateUrl: './list-facturas.component.html',
  styleUrls: ['./list-facturas.component.scss']
})
export class ListFacturasComponent implements OnInit {
  public optionFormGroup: FormGroup;
  public RFC = new FormControl('');
  public rfc: InvoiceData = null;

  constructor(
    private dialogRef: MatDialogRef<ListFacturasComponent>,
    @Inject(MAT_DIALOG_DATA) public listInvoice: InvoiceData[] = [],
    private formBuilder: FormBuilder,
    public formDialog: MatDialog,
    private serviceRFCs: RFCsService,
  ) { }

  ngOnInit(): void {
  }

  public get InputValue(): string {
    return this.RFC.value;
  }
  
  public openForm = () => {
    const dialogRef = this.formDialog.open(FormFacturaComponent, {
      width: '50%',
      // autoFocus: false
    });
    dialogRef.afterClosed().pipe(
      switchMap((result) => {
        if (result) {
          return this.serviceRFCs.insertNewRFCs(result);
        }
        return of(null);
      })).pipe(
        switchMap((resultNewRfc) => {
          if (resultNewRfc) {
            if (resultNewRfc.estatus) {
              return this.serviceRFCs.getAllListRFCs();
            }
          }
          return of(null);
        })
      ).subscribe((listRFCs) => {
        if (listRFCs) {
          this.listInvoice = listRFCs.respuesta;
        }
      });
  }
  
  public getRFC = (item: InvoiceData): void => {
    this.rfc = item;
  }

  public guardarCambios = (): void => {
    this.dialogRef.close(this.rfc);
  }
}
